<template>
  <div class="l-forget-inner">
    <transition-group name="forget">
      <div class="l-forget-main" :key=1>
        <div class="l-input-box">
          <span class="l-title">账号:</span>
          <div class="l-input-container">
            <div class="l-input-main">
              <input
                type="text"
                placeholder="请输入账号"
                autocomplete="new-password"
                v-model.trim="form.phone"
                @blur="onTestPhone"
                class="l-input"
                maxlength="11"
              />
            </div>
            <div class="l-error-msg" v-show="error.phone">{{ error.phone }}</div>
          </div>
        </div>

        <div class="l-input-box">
          <span class="l-title">验证码:</span>
          <div class="l-input-container">
            <div class="l-input-main">
              <input
                type="text"
                placeholder="请输入验证码"
                autocomplete="new-password"
                v-model.trim="form.verifyCode"
                @blur="onTestVerifyCode"
                maxlength="5"
                class="l-input l-input-half"
              />
              <button type="button" class="l-btn-code">
                <span
                  @click="onGetSMS()"
                  v-if="!isShowCaptchaButton"
                  class="l-code-text"
                  >获取验证码</span
                >
                <span v-else class="l-code-time">{{ captchaCount }}s</span>
              </button>
            </div>
            <div class="l-error-msg" v-show="error.verifyCode">{{ error.verifyCode }}</div>
          </div>
        </div>

        <div class="l-input-box">
          <span class="l-title">新密码:</span>
          <div class="l-input-container">
            <div class="l-input-main">
              <input
                type="password"
                placeholder="8~22位数字和字母的组合"
                autocomplete="new-password"
                v-model.trim="form.newPassword"
                @blur="onTestPassword"
                class="l-input"
                minlength="8"
                maxlength="22"
              />
            </div>
            <div class="l-error-msg" v-show="error.newPassword">{{ error.newPassword }}</div>
          </div>
        </div>

        <div class="l-input-box">
          <span class="l-title">确认密码:</span>
          <div class="l-input-container">
            <div class="l-input-main">
              <input
                type="password"
                placeholder="8~22位数字和字母的组合"
                autocomplete="new-password"
                v-model.trim="form.conPassword"
                @blur="onTestConfirmPassword"
                class="l-input"
                minlength="8"
                maxlength="22"
              />
            </div>
            <div class="l-error-msg" v-show="error.conPassword">{{ error.conPassword }}</div>
          </div>
        </div>

        <div class="l-btn-container">
          <button class="l-btn l-btn-cancel" @click="onCancel">取消</button>
          <button class="l-btn l-btn-submit" @click="onSubmit">确定</button>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import UsercenterModel from '@/models/usercenter'

const usercenterModel = new UsercenterModel()

export default {
  props: {
    phone: {
      type: String
    },
  },
  data() {
    return {
      captchaCount: 60, // 倒计时
      isShowCaptchaButton: false, // 获取验证码按钮
      form: {
        phone: '',
        verifyCode: '',
        newPassword: '',
        conPassword: ''
      },
      // 错误信息
      error: {
        phone: '',
        verifyCode: '',
        newPassword: '',
        conPassword: '',
      }
    }
  },
  watch:{
    phone(val) {
      if (val) {
        this.form.phone = val
      }
    }
  },
  created() {
    this.form.phone = this.phone
  },
  methods: {
    // 获取验证码
    onGetSMS () {
      if (this.onTestPhone()){
        usercenterModel.getVerifyCodeForget({
          phone: this.form.phone
        }).then(() => {
          this.isShowCaptchaButton = true
          this._countdown()
        }).catch((error) => {
          this.$lPrompt({
            message: error.msg,
            successTxt: '确定'
          })
        })
      }
    },
    // 60s倒计时
    _countdown () {
      this.countdownTimer = setInterval(() => {
        this.captchaCount--
        if (this.captchaCount === 0) {
          clearInterval(this.countdownTimer)
          this.isShowCaptchaButton = false
          this.captchaCount = 60
        }
      }, 1000)
    },
    // 验证手机号
    onTestPhone() {
      const regPhone = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
      if (this.form.phone == '') {
        this.error.phone = '请输入手机号'
        return false
      } else if (!regPhone.test(this.form.phone)) {
        this.error.phone = '手机号格式错误'
        return false
      } else {
        this.error.phone = ''
        return true
      }
    },
    // 验证密码
    onTestPassword() {
      const regPassword = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,22}$/
      if (this.form.newPassword == '') {
        this.error.newPassword = '请输入新密码'
        return false
      } else if (!regPassword.test(this.form.newPassword)) {
        this.error.newPassword = '新密码格式错误'
        return false
      } else {
        this.error.newPassword = ''
        return true
      }
    },
    // 验证确认密码
    onTestConfirmPassword() {
      const regPassword = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,22}$/
      if (this.form.conPassword == '') {
        this.error.conPassword = '请输入确认密码'
        return false
      } else if (!regPassword.test(this.form.conPassword)) {
        this.error.conPassword = '确认密码格式错误'
        return false
      } else if ( this.form.newPassword != this.form.conPassword ) {
        this.error.conPassword = '两次密码输入不一致'
        return false
      } else {
        this.error.conPassword = ''
        return true
      }
    },
    // 验证验证码
    onTestVerifyCode() {
      if (this.form.verifyCode == '') {
        this.error.verifyCode = '请输入验证码'
        return false
      } else {
        this.error.verifyCode = ''
        return true
      }
    },
    // 点击取消
    onCancel() {
      this.$emit("cancel")
    },
    // 点击确认
    onSubmit () {
      if (
        this.onTestPhone() && 
        this.onTestVerifyCode() &&
        this.onTestPassword() && 
        this.onTestConfirmPassword()
      ){
        usercenterModel.modifyPassword(this.form).then((res) => {
          if (res.data) {
            const that = this
            this.$lPrompt({
              message: '重置密码成功！',
              successTxt: '确定',
              successFn: function () {
                that.$emit("submit", that.form.phone)
              },
            })
          }
        })
        .catch((error) => {
          this.$lPrompt({
            message: error.msg,
            successTxt: '确定'
          })
        })
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>